import { PhasrMonitoredRulesWebComponent } from './component/PhasrMonitoredRulesWebComponent';
import { WEB_COMPONENT_PHASR_MONITORED_RULES } from '../../webcomponents.constants';

export { PhasrMonitoredRulesWebComponent };

window.customElements.define(WEB_COMPONENT_PHASR_MONITORED_RULES, PhasrMonitoredRulesWebComponent);